<style scoped lang="less">
  .flex {
    display: flex;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #footer {
    position: relative;
    width: 100%;
    font-size: 14px;
    .bottom {
      height: 39px;
      border-top: 1px solid #f4f4f4;
      p {
        font-size: 12px;
        color: #999999;
        line-height: 39px;

        a {
          color: #999;
        }
      }
    }

    .nav {
      width: 100%;
      color: #fff;
      background: #0077db;
      opacity: 0.5;
      height: 40px;
      /*line-height: 20px;*/

      .nav-item {
        padding: 0 10px;
        border-right: 1px solid #fff;
        border-left: 1px solid #fff;

        a {
          color: #fff;
        }
      }

      :last-child {
        border-right: none;
      }
      :first-child {
        border-left: none;
      }
    }

    .link-con {
      height: 150px;
      padding: 0 20%;

      .left {
        text-align: center;
      }

      .right {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex: 7;
        .title {
          background: #ddd;
          padding: 5px;
        }
        .friend-link {
          div {
            display: inline-block;
            word-break: keep-all;
            word-wrap: break-word;
            margin: 2px 5px;
            font-size: 12px;

            a {
              color: #666;
            }
          }
        }
      }
    }
  }

</style>

<template>
  <div id="footer" class="footer">
    <div>
      <div class="nav flex flex-center">
        <div class="nav-item">
          <router-link :to="{ name: 'about-us', params: { liName: 'about' }}" target="_blank" rel="nofollow">关于我们</router-link>
        </div>
<!--        <div class="nav-item">-->
<!--          <router-link to="/recruitment" target="_blank" rel="nofollow">加入我们</router-link>-->
<!--        </div>-->
        <div class="nav-item">
          <router-link :to="{ name: 'about-us', params: { liName: 'invoice' }}" target="_blank" rel="nofollow">索取发票</router-link>
        </div>
        <div class="nav-item">
          <router-link :to="{ name: 'about-us', params: { liName: 'refund' }}" target="_blank" rel="nofollow">退款说明</router-link>
        </div>
        <div class="nav-item">
          <router-link :to="{ name: 'about-us', params: { liName: 'pay' }}" target="_blank" rel="nofollow">支付方式</router-link>
        </div>
        <div class="nav-item">
          <router-link :to="{ name: 'about-us', params: { liName: 'contact' }}" target="_blank" rel="nofollow">联系我们</router-link>
        </div>
        <div class="nav-item">
          <router-link :to="{ name: 'about-us', params: { liName: 'protocol' }}" target="_blank" rel="nofollow">用户协议</router-link>
        </div>
      </div>
    </div>

    <div class="link-con flex flex-center">
      <div class="flex">
        <div class="left flex flex-center" style="flex: 3;">
          <div>
            <a class="finance_btn" href="http://tax.qiyewan.com" target="_blank" rel="nofollow">
              <img src="//v3.cdn.qiyewan.com/footer-internal-finance.png" style="width: 82px;height: 81px;margin:5px 5px;">
            </a>
            <p>内部财税</p>
          </div>
          <div>
            <img src="//v3.cdn.qiyewan.com/erweima.png" style="width: 82px;height: 81px;margin:5px 0;">
            <p>关注服务号</p>
          </div>
          <div>
            <img src="//v3.cdn.qiyewan.com/erweima1.jpg" style="width: 90px;height: 91px;">
            <p>关注订阅号</p>
          </div>
        </div>
        <div v-if="$route.path === '/'" class="right flex">
          <span class="title">
            友情链接
          </span>
          <div class="friend-link">
            <div v-for="item in friendLinks" :key="item.title">
              <a target="_blank" :href="item.url">{{item.title}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom flex-center">
      <p>
        Copyright @ 2015-2019 www.qiyewan.com 企业湾 备案号：
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="nofollow">沪ICP备15043250号-2</a>
        <a href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202004875" target="_blank"
           rel="nofollow" style="padding-left:30px;">
          <img src="//www.beian.gov.cn/img/ghs.png" alt="ghs" style="width: 16px;vertical-align: middle">
          沪公网安备 31011202004875号
        </a>
      </p>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        friendLinks: [
          // {url: 'http://www.gdian168.com', title: ' 天猫店铺转让'},
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OldFooter.vue?e402ae72